import { render, staticRenderFns } from "./editSupplierCoupon.vue?vue&type=template&id=5e67a184"
import script from "./editSupplierCoupon.vue?vue&type=script&lang=js"
export * from "./editSupplierCoupon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_29ccf6a1548590c1291b44f0faebdb79/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports